import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Store, persistor } from './redux/store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { fetchWithNetworkError } from './utils/apiNetworkError';
import { Capacitor } from '@capacitor/core';
import { validateAppTokenRequest } from './redux/appToken/appTokenIndex';
import { checkRootDetectionRequest } from './redux/rootDetection/rootDetectionIndex';
globalThis.fetch = fetchWithNetworkError;

if (Capacitor.isNativePlatform()) {
  Store.dispatch(validateAppTokenRequest());
  Store.dispatch(checkRootDetectionRequest());
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={Store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
